



















import BaseInput from "../models/base.input";
import { Prop } from "vue-property-decorator";
import Component from "vue-class-component";
@Component({
  props: ["options", "disabled"]
})
export default class Select extends BaseInput {    
    
    @Prop()
    options: any;
}        
